import { Component, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { AppBase } from '../../app-base';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-community',
  templateUrl: './modal-community.component.html',
  styleUrls: ['./modal-community.component.sass']
})
export class ModalCommunityComponent extends AppBase {
  @ViewChild('childModal') public childModal: ModalDirective;
  public modalRef: BsModalRef;

  constructor(private router: Router) {
    super();
  }

  public openModal() {
    this.childModal.show();
  }

  public logout() {
    this.cleanStorage();
    this.childModal.hide();
  }

  public gothere() {
    this.router.navigate(['/home-community']);
    window.location.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/modal-community/modal-community.component.ts